export default function RentalsHero() {
  return (
    <section className="relative pt-24 pb-0 min-h-[52vh] flex items-end overflow-hidden">
      <div className="absolute inset-0 w-full h-full">
        <img
          src="https://readdy.ai/api/search-image?query=modern%20Australian%20residential%20property%20exterior%20bright%20sunny%20day%2C%20neat%20front%20yard%2C%20contemporary%20house%20facade%2C%20well-maintained%20suburban%20home%2C%20clean%20and%20welcoming%20curb%20appeal%2C%20professional%20real%20estate%20photography&width=1920&height=620&seq=rentals-hero1&orientation=landscape"
          alt="Galaxy Housing available rentals"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-navy-900/65 to-navy-950/90" />
      </div>
      <div className="relative z-10 w-full max-w-7xl mx-auto px-6 pb-14">
        <div className="flex items-center gap-3 mb-4">
          <div className="w-8 h-0.5 bg-gold-400" />
          <span className="text-gold-400 text-sm font-medium tracking-widest uppercase">Regional &amp; Metro Australia</span>
        </div>
        <h1 className="font-heading text-5xl lg:text-6xl font-bold text-white leading-tight mb-4 max-w-2xl">
          Available Rental Properties
        </h1>
        <p className="text-white/65 text-lg max-w-xl">
          Browse our current vacancies across regional towns and metro cities. All rooms are fully furnished, all-inclusive, and professionally managed.
        </p>
      </div>
    </section>
  );
}
